import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_AI_SUMMARY = "GET_AI_SUMMARY";

export const service = async (data) => {
  const options: object = {
      url: `/Api/AISummary/GetAISummaryAsync?liveBoardId=${data.liveBoardId}`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};
const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_AI_SUMMARY, service, mock);
